import React, { FC, memo, useMemo } from 'react';
import { Select } from 'udesk-ui';
import { SelectProps } from 'udesk-ui/lib/select';

interface TemplateProps extends SelectProps<string> {}

const Template: FC<TemplateProps> = memo((props) => {
    const { ...restProps } = props;

    const options = useMemo(() => {
        return [
            {
                value: 'zh',
                // no-locale-translate
                label: '简体中文',
            },
            {
                value: 'en',
                label: /* 英语 */ 'English',
            },
            {
                value: 'tw',
                // no-locale-translate
                label: '繁體中文',
            },
            {
                value: 'hk',
                // no-locale-translate
                label: /* 粤语 */ '粵語',
            },
            {
                value: 'fr',
                // no-locale-translate
                label: /* 法语 */ 'Français',
            },
            {
                value: 'es',
                // no-locale-translate
                label: /* 西班牙语 */ 'Español',
            },
            {
                value: 'ja',
                // no-locale-translate
                label: /* 日语 */ '日本語',
            },
            {
                value: 'th',
                // no-locale-translate
                label: /* 泰语 */ 'ภาษาไทย',
            },
            {
                value: 'ms',
                // no-locale-translate
                label: /* 马来语 */ 'Bahasa Melayu',
            },
            {
                value: 'id',
                // no-locale-translate
                label: /* 印尼语 */ 'Bahasa Indonesia',
            },
            {
                value: 'vi',
                // no-locale-translate
                label: /* 越南语 */ 'Tiếng Việt',
            },
            {
                value: 'pt',
                // no-locale-translate
                label: /* 葡萄牙语 */ 'Português',
            },
            {
                value: 'ko',
                // no-locale-translate
                label: /* 韩语 */ '한국어',
            },
            {
                value: 'tl',
                // no-locale-translate
                label: /* 菲律宾语 */ 'Filipino',
            },
            {
                value: 'kh',
                // no-locale-translate
                label: /* 柬埔寨语 */ 'កាបូដូសName',
            },
            {
                value: 'ru',
                // no-locale-translate
                label: /* 俄语 */ 'Русский язык',
            },
            {
                value: 'ar',
                // no-locale-translate
                label: /* 阿拉伯语 */ 'العربية',
            },
            {
                value: 'tr',
                // no-locale-translate
                label: /* 土耳其语 */ 'Türkçe',
            },
            {
                value: 'de',
                // no-locale-translate
                label: /* 德语 */ 'Deutsch',
            },
            {
                value: 'it',
                // no-locale-translate
                label: /* 意大利语 */ 'Italiano',
            },
            {
                value: 'el',
                label: /* 希腊语 */ 'Ελληνική',
            },
            {
                value: 'fi',
                // no-locale-translate
                label: /* 芬兰语 */ 'Suomen kieli',
            },
            {
                value: 'pl',
                // no-locale-translate
                label: /* 波兰语 */ 'Polskie',
            },
            {
                value: 'nl',
                // no-locale-translate
                label: /* 荷兰语 */ 'Nederlands',
            },
            {
                value: 'cs',
                // no-locale-translate
                label: /* 捷克语 */ 'Czech',
            },
        ];
    }, []);

    return <Select options={options} {...restProps} />;
});

export default Template;
